<template>
  <Text>
    {{ t('sidebar_status.uptime') }}
    <Text tag="span" class="tw-font-black">{{ uptimeText }}</Text>
    <template v-if="startedAtText">
      ({{ t('sidebar_status.started_at') }} <Text tag="span" class="tw-font-black">{{ startedAtText }}</Text
      >)
    </template>
  </Text>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

import { Text } from '@slideslive/fuse-kit/vue';

defineProps({
  uptimeText: { type: String, required: true },
  startedAtText: { type: String, default: null },
});

const { t } = useI18n();
</script>
